import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import FilterSelect from '../modules/filter-select';

class HomeLatestProductSliderHandler {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.sliderEl = this.root.querySelector('.home-lastest-product-slider');
        this.sliderItems = this.root.querySelectorAll('.swiper-slide');

        this.filterSelectEl = this.root.querySelector('[filter-select]');
        this.filterSelectInstance = null;
        this.swiperInstance = null;

        this.currentValue = 'all';

        return true;
    }

    init() {
        this.initSlider();
        this.setFilterSelectEl();
    }

    setFilterSelectEl() {
        if (!this.filterSelectEl) return;
        this.filterSelectInstance = new FilterSelect(
            this.filterSelectEl,
            this.root
        );

        this.root.addEventListener('filter-select-item-swap', () => {
            //this.setCategoryEl();
        });

        this.root.addEventListener('filter-select-change', event => {
            const { detail } = event;
            const { value } = detail;

            if (value && value !== '') this.changeSlider(value);
        });
    }

    initSlider() {
        this.swiperInstance = new Swiper(this.sliderEl, {
            modules: [Autoplay, Navigation, Pagination],
            loop: false,
            speed: 650,
            slidesPerView: 2,
            spaceBetween: 40,
            breakpoints: {
                760: {
                    slidesPerView: 3,
                },
                1080: {
                    slidesPerView: 5,
                    spaceBetween: 48,
                },
                1536: {
                    slidesPerView: 7.25,
                    spaceBetween: 48,
                },
            },
        });
    }

    changeSlider(value) {
        if (value == this.currentValue) return;
        this.currentValue = value.trim();

        if (value !== 'all') {
            this.sliderItems.forEach(item =>
                item.classList.remove('swiper-slide')
            );
            this.sliderItems.forEach(item => {
                if (item.classList.contains(this.currentValue)) {
                    item.classList.add('swiper-slide');
                }

                if (item.classList.contains('fake')) item.classList.add('swiper-slide');
            });
        } else {
            this.sliderItems.forEach(item =>
                item.classList.add('swiper-slide')
            );
        }

        // Reinitialize slider to reflect changes
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
        }

        this.initSlider();
    }
}

const sections = document.querySelectorAll('[home-latest-product]');
const initHomeProducts = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new HomeLatestProductSliderHandler(el);
    });
};

initHomeProducts(sections);
